// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-col[data-v-1aefeef9]{list-style:none;padding-left:0;margin-left:0}.footer-link[data-v-1aefeef9]{text-decoration:none;color:#fff}.footer-link[data-v-1aefeef9]:hover{color:#2eac68}", ""]);
// Exports
module.exports = exports;
